import React, { useEffect, useState } from "react";
import StudentTopMenu from "./studenttopmenu";
import { useParams } from "react-router-dom";
import StudentInfoBox from "./studentinfobox";
import GlobalStudentLesson from "../../pages/common/globalstudentlessonforgrade";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu";
import PageNotes from "../../pages/common/pagenotesnew";
import GlobalStudentLesson2 from "../../pages/common/globalstudentlesson2";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu";
import InstructorStudentCoursesReport from "./studentcoursesreport";
import { Nav, Tab } from "react-bootstrap";

export default function InstructorStudentLesson() {
  const { profile } = useAuth();
  let { slug } = useParams();
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);
  const [activeTab, setActiveTab] = useState("listOfCourses"); // 'lessons' or 'report'

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="tak-instruct-group">
      <div className="row">
        <div className="col-md-12">
          {isStudent911 && (
            <Student911TopMenu slug={slug} activeMenu={"Lessons"} />
          )}
          {isStudent12 && (
            <Student12TopMenu slug={slug} activeMenu={"Lessons"} />
          )}
          <PageNotes
            type={"Instructor"}
            pageName={"Task"}
            studentId={slug}
            instructorId={profile.id}
          />
          <Tab.Container
            defaultActiveKey="listOfCourses"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="listOfCourses">List of Courses</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="courseReport">Course Report</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="listOfCourses">
                <GlobalStudentLesson2 slug={slug} isStudent={false} />
              </Tab.Pane>
              <Tab.Pane eventKey="courseReport">
                <InstructorStudentCoursesReport />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
}
